import axios from 'axios';
import { environment } from '../../../../../environment/environment';
import { TwoFactorStatusResponse } from '../Response';
import { GetTwoFactorRequest, UpdateTwoFactorRequest } from '../Request';

const BASE_URL = environment.baseUrl;

export class TwoFactorAuthApiService  {
  /**
   * Fetch the current 2FA status for a user
   */
  async get({ userId }: GetTwoFactorRequest): Promise<TwoFactorStatusResponse> {
    const response = await axios.get(`${BASE_URL}/users/2fa/${encodeURIComponent(userId)}`);
    return response.data;
  }

  /**
   * Update the 2FA method for a user
   */
  async update({ userId, method }: UpdateTwoFactorRequest): Promise<void> {
    await axios.post(`${BASE_URL}/users/2fa/${encodeURIComponent(userId)}/`, { method });
  }
};

export const twoFactorAuthApiService = new TwoFactorAuthApiService();